import { SvgIcon } from '@material-ui/core'

export default function AccessibilityIcon(props: any) {
    return (
        <SvgIcon style={{ width: '26px', height: '26px' }} viewBox="40 27 25 25" fill="none" {...props}>
            <g clipPath="url(#clip0_accessibility)">
                <path
                    d="M65 40C65 33.3617 59.6018 28 53 28C46.3982 28 41 33.3617 41 40C41 46.6383 46.3617 52 53 52C59.6383 52 65 46.6383 65 40ZM53 30.6261C54.1307 30.6261 55.0426 31.538 55.0426 32.6687C55.0426 33.7994 54.1307 34.7112 53 34.7112C51.8693 34.7112 50.9574 33.7994 50.9574 32.6687C50.9574 31.5745 51.8693 30.6261 53 30.6261ZM50.0091 49.0821C49.8632 49.0821 49.7173 49.0456 49.5714 48.9726C49.0243 48.7173 48.8055 48.0973 49.0608 47.5501C49.0608 47.5501 51.0669 42.9544 51.4316 41.2766C51.5775 40.693 51.6505 39.1246 51.6869 38.3951C51.6869 38.1398 51.541 37.921 51.3222 37.848L46.8359 36.4985C46.2523 36.3161 45.924 35.696 46.1064 35.1489C46.2888 34.6018 46.9088 34.3465 47.4559 34.4924C47.4559 34.4924 51.5775 35.8055 53.0365 35.8055C54.4954 35.8055 58.69 34.4559 58.69 34.4559C59.2371 34.31 59.8571 34.6383 60.003 35.1854C60.1489 35.7325 59.8207 36.3526 59.2736 36.4985L54.7872 37.848C54.5684 37.921 54.386 38.1398 54.4225 38.3951C54.459 39.1246 54.5319 40.693 54.6778 41.2766C55.0426 42.9544 57.0486 47.5501 57.0486 47.5501C57.304 48.0973 57.0486 48.7173 56.538 48.9726C56.3921 49.0456 56.2462 49.0821 56.1003 49.0821C55.6991 49.0821 55.2979 48.8632 55.152 48.462L53 44.0851L50.9574 48.4985C50.7751 48.8632 50.4103 49.0821 50.0091 49.0821Z"
                    fill="url(#paint0_linear_accessibility)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_accessibility"
                    x1="53"
                    y1="28"
                    x2="53"
                    y2="52"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <clipPath id="clip0_accessibility">
                    <rect width="24" height="24" fill="white" transform="translate(41 28)" />
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
